module.exports = __webpack_public_path__ + "img/madeira.35177a5d.png";